export default {
  hi_im_neela: 'Hej, jag är Neela,',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: ' virtuell Aareon-assistent.',
  media: 'Media',
  media_link: 'https://neela.aareon.com/media',
  contact: 'Kontakt',
  contact_link: 'https://neela.aareon.com/contact',
  privacy: 'Integritet',
  privacy_link: 'https://www.aareon.com/sixcms/detail.php/3627',
  terms_of_use: 'Användarvillkor',
  terms_of_use_link: 'https://www.aareon.com/sixcms/detail.php/3621',
  legal_notice: 'Juridiskt meddelande',
  legal_notice_link: 'https://neela.aareon.com/legal',
  show_system_messages: 'Visa systemmeddelanden',
  dont_show_system_messages: 'Dölj systemmeddelanden',
  logged_in: 'Hyresgäst är verifierad',
  logged_out: 'Anonym användare',
  button_switch_locale: 'Ändra språk',
  button_tooltip_activate_voice_recognition: 'Aktivera röstigenkänning',
  date_input: 'Välj datum',
  choose_two_dates: 'Välj två datum',
  date_range: 'Datumintervall',
  from: 'från',
  to: 'till',
  avatar: 'Avatar',
  exit: 'Avsluta',
  new: 'Ny',
  back: 'Tillbaka',
  suggestions: 'Förslag',
  senton: 'Skickat den',
  message_placeholder: 'Skriv meddelande här',
  comment_placeholder: 'Enter comment here',
  file_max_upload_text: 'A maximum of 20 files can be uploaded',
  message_button_label: 'Skicka',
  please_confirm: 'Bekräfta',
  no: 'Nej',
  yes: 'Ja',
  modal_delete_session: 'Radera session',
  modal_delete_session_notification:
    'Om du stänger fönstret, kommer din session att raderas. <br>Är du säker?',
  template_contact_time: 'När kan vi kontakta dig?',
  template_pause:
    'Din session har pausats. En av vår supportpersonal kommer att ta hand om din förfrågan inom kort.',
  template_continue_after_pause:
    'Din session har återupptagits. Du kan du fortsätta skriva till vår chattrobot.',
  button_apply: 'Tillämpa',
  button_cancel: 'Avbryt',
  none: 'Ingen',
  book_appointment: 'Boka möte',
  address_input: 'Adress',
  data_processing: 'Databehandling',
  privacy_policy: 'Integritetspolicy',
  data_processing_notification_before_link:
    'För att använda denna chatt-tjänst måste du acceptera ',
  data_processing_notification_after_link: '.',
  button_accept: 'Acceptera',
  select_date: 'Välj datum',
  rate_conversation: 'Hur skulle du betygsätta denna konversation?',
  new_ticket_question: 'Är det något annat jag kan hjälpa till med?',
  thank_you:
    'Tack för din support. Din feedback hjälper mig att ständigt förbättra mig själv.',
  goodbye: 'Hej då.',
  start_new: 'Starta ny konversation',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_SV_BG,
  expand_quickreplies: 'Mer',
  collapse_quickreplies: 'Färre',
  login: 'Logga in',
  logout: 'Logga ut',
  close: 'Stäng',
  maximize: 'Maximize',
  minimize: 'Minimize',
  feedback_helpful: 'Detta svar hjälpte mig',
  feedback_not_helpful: 'Detta svar hjälpte mig inte',
  chatProtocol: 'ProtokollFörChatt',
  showMore: 'Visa mer',
  showLess: 'Visa mindre',
  uploadTooltip: 'Ladda upp en fil',
  uploadFilesTooltip: 'Ladda upp filer',
  pdfDownloadTooltip: 'Ladda ner konversation',
  feedbackDescription: 'Feedback till oss',
  feedbackSubtitle: {
    description:
      'Här kan du skicka oss allmänna förslag, förslag och önskemål.',
    note: 'Observera att vi inte kan svara på dem.',
    hint:
      'Alla andra frågor som specifikt rör din hyresrätt eller sökandet efter en lägenhet kan du beskriva för oss i chatten.'
  },
  feedbackPlaceholder: 'Ange ditt meddelande här...',
  sendFeedback: 'Skicka',
  giveFeedback: 'Feedback till oss',
  feedbackSubmittedSuccessfully: 'Ditt feedback har skickats framgångsrikt',
  thanks: 'Tack'
}
